import { Box, Heading, Text, VStack, Image } from '@everlywell/ui-kit';
import React, { memo } from 'react';

interface ContentItem {
  heading: string;
  description: {
    childMarkdownRemark: {
      rawMarkdownBody: string;
    };
  };
  image: {
    url: string;
    alt?: string | null;
  };
}

interface HowItWorksProps {
  title?: string;
  headline: string;
  description?: {
    description: string;
  };
  listOfContentWithImages: ContentItem[];
  backgroundColor?: string;
}

const HowItWorks: React.FC<HowItWorksProps> = memo(
  ({
    title,
    headline,
    description,
    listOfContentWithImages,
    backgroundColor,
  }) => (
    <Box
      as="section"
      id="how-it-works"
      width="100%"
      py={[16, 20]}
      px="1rem"
      backgroundColor={backgroundColor}
    >
      <Box maxWidth="1440px" mx="auto" data-testid="how-it-works">
        <Box
          display="flex"
          flexDirection={['column', 'column', 'row']}
          gap={4}
          width="100%"
        >
          <VStack
            spacing={4}
            alignItems={['center', 'flex-start']}
            maxWidth={['700px', '700px', '400px']}
            mx="auto"
          >
            <VStack spacing={2} width="100%">
              {title && (
                <Text
                  color="#28724F"
                  fontSize="1rem"
                  textAlign={['center', 'center', 'left']}
                  width="100%"
                >
                  {title}
                </Text>
              )}
              <Heading
                size="xl"
                textAlign={['center', 'center', 'left']}
                width="100%"
              >
                {headline}
              </Heading>
            </VStack>
            <Text
              size="md"
              color="gray.600"
              textAlign={['center', 'center', 'left']}
              width="100%"
              maxWidth={['100%', '300px', '300px']}
            >
              {description?.description}
            </Text>
          </VStack>
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            gap={8}
            width="100%"
          >
            {listOfContentWithImages?.map((item, index) => (
              <Box
                key={`how-it-works-item-${index}`}
                px={['1.5rem', '1rem', '0rem']}
                width={[
                  '100%',
                  index === listOfContentWithImages.length - 1 &&
                  listOfContentWithImages.length % 2 === 1
                    ? '96%'
                    : '46%',
                ]}
              >
                <VStack width="100%">
                  <Image
                    src={item.image?.url}
                    alt={item.image?.alt || item.heading}
                    width="100%"
                    height="auto"
                    borderRadius="lg"
                    loading="lazy"
                  />
                  <Heading
                    fontSize="20px"
                    fontWeight="semibold"
                    textAlign={['center', 'center', 'left']}
                    width="100%"
                  >
                    {item.heading}
                  </Heading>
                  <Text
                    size="md"
                    color="#545454"
                    width="100%"
                    textAlign={['center', 'center', 'left']}
                  >
                    {item.description?.childMarkdownRemark?.rawMarkdownBody}
                  </Text>
                </VStack>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  ),
);

export default HowItWorks;
